import { render } from "./Brand.vue?vue&type=template&id=36ff4e90&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=36ff4e90&scoped=true&lang=css"
import "./Brand.vue?vue&type=style&index=1&id=36ff4e90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ff4e90"]])

export default __exports__